
import { SidebarProvider } from "@/components/ui/sidebar";
import { AdminSidebar } from "@/components/AdminSidebar";
import { AdminTab } from "@/components/admin-users/AdminTab";
import { useAdminAuth } from "@/hooks/useAdminAuth";

const AdminUsers = () => {
  // Use admin auth hook to protect this page
  useAdminAuth();

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-gray-100">
        <AdminSidebar />
        <div className="flex-1">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="mb-12">
              <div>
                <h1 className="text-4xl font-bold" style={{ color: "#008169" }}>
                  Admin Management
                </h1>
                <p className="text-xl text-gray-600 mt-2">
                  Manage admin users and permissions
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-sm p-6">
              <AdminTab />
            </div>
          </div>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default AdminUsers;
